import { css, jsx } from '@emotion/react';
import { Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../universal-nav/hooks';
import { baseReset, boxSizing, listReset, } from '../../../utils/style-mixins/reset';
const Styles = {
    root: css `
    ${boxSizing};
    display: grid;
    grid-template-columns: 100%;
    gap: 10px;
    justify-items: center;
    font: var(--zds-small-print-1);
    text-align: center;

    @media screen and (min-width: 650px) {
      gap: 20px;
    }
  `,
    title: css `
    ${baseReset};
    color: var(--zds-gray-warm-10, #201515);
    font: var(--zds-body-4);
  `,
    links: css `
    ${listReset};
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  `,
    link: css `
    ${boxSizing};
    font: var(--zds-body-1);
    // Increase hit size.
    display: block;
    padding: 0px;
    margin: 0px 10px;
    white-space: nowrap;
    flex: none;
    color: var(--zds-gray-warm-9, #413735);
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: var(--zds-ui-primary-strongest, #503ebd);
      outline: none;
    }

    @media screen and (max-width: 768px) {
      margin: 0px 6px;
    }
  `,
};
const letters = ['0–9', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];
export const AlphabeticAppNav = ({ baseUrl = '/find-apps/', title = 'Apps by Title', }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkItems = letters.map((letter) => {
        const href = `${baseUrl}/${letter.toLowerCase()}`
            .replace('//', '/')
            .replace('–', '-');
        return (jsx("li", { key: letter, "data-zds": true },
            jsx(Link, { "aria-label": `${letter} — Apps beginning with ${letter}`, color: null, css: Styles.link, href: getFullyQualifiedURL(href) }, letter)));
    });
    return (jsx("section", { css: Styles.root, "data-zds": true },
        jsx("h2", { css: Styles.title, "data-zds": true }, title),
        jsx("ul", { css: Styles.links, "data-zds": true }, linkItems)));
};
//# sourceMappingURL=AlphabeticAppNav.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
